export function getAwinParam(params: URLSearchParams): string | null {
  return params.get('awc')
}
